import { useAtomValue } from "@effect-atom/atom-react";
import {
  selectedEngineAtom,
  transformStatusAtom,
  apiConnectedAtom,
} from "../atoms";
import { EngineNames } from "../lib/schemas";

export function StatusBar() {
  const selectedEngine = useAtomValue(selectedEngineAtom);
  const transformStatus = useAtomValue(transformStatusAtom);
  const apiConnected = useAtomValue(apiConnectedAtom);

  const apiStatus =
    apiConnected === null
      ? "API: Connecting..."
      : apiConnected
        ? "API: Connected"
        : "API: Disconnected";

  const apiStatusClass =
    apiConnected === null
      ? ""
      : apiConnected
        ? "connected"
        : "disconnected";

  return (
    <div className="status-bar">
      <div className="status-left">
        <span id="engineStatus">Engine: {EngineNames[selectedEngine]}</span>
        <span id="transformStatus">{transformStatus}</span>
      </div>
      <div className="status-right">
        <span id="apiStatus" className={apiStatusClass}>
          {apiStatus}
        </span>
      </div>
    </div>
  );
}
